import styled from 'styled-components'
import { mainColor } from '../../styles/global';

export const FaqWrapper = styled.div`
  padding: 2rem 7%;
  background: #F4F7FF;
`;


export const FaqTitle = styled.div`
  text-align: center;
  display:flex;
  justify-content: center;
  align-items: center;
  font-family: 'Avenir';
  font-weight: 800;
  font-size: 45px;
  line-height: 65px;
  margin:20px auto;
  text-align: justify;
  letter-spacing: 0.01em;
  color:${mainColor};
  @media screen and (max-width: 768px) {
      font-family: 'Avenir';
      font-style: normal;
      font-weight: 750;
      font-size: 27px;
      line-height: 33px;
      text-align: center;
      letter-spacing: 0.01em;
      width: 100%;

  }

`;
export const FaqCategory = styled.div`
    color:${mainColor};
    line-height:80px;
    font-size:40px;
    font-weight:bold;
    padding-left: 20px;
    @media screen and (max-width: 768px) {
       font-size:25px;
      line-height:50px;
      padding-left: 3px;
  }

`;
export const SearchFaqBox = styled.div`
  >form{
      display: flex;
      justify-content:center;
    input{
        width:80%;
        margin:50px 0px 10% 0px;
        padding:3%;
        border-radius:5px;
        background:rgb(251,251,251);
        border:1px solid rgb(221,221,221);
        ::placeholder{
          font-size:20px;
        }
        @media screen and (max-width: 768px) {
          width: 100%;
          padding:20px;
          ::placeholder{
            font-size:14px;
          }
    
      }
    }
  }

`;

